import { render, staticRenderFns } from "./add&edit.vue?vue&type=template&id=4a4b3e2c&scoped=true&"
import script from "./add&edit.vue?vue&type=script&lang=js&"
export * from "./add&edit.vue?vue&type=script&lang=js&"
import style0 from "./add&edit.vue?vue&type=style&index=0&id=4a4b3e2c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b3e2c",
  null
  
)

export default component.exports